/**
 * Stop command - sessions auto-sleep, so this informs the user
 * and offers to destroy the session instead.
 */

import chalk from 'chalk';
import { SANDBOX_WORKER_URL } from '@spacecode/shared/remote';
import { resolveAuthToken, sandboxClientOptions } from '../config.js';

export async function stop(sessionId: string): Promise<void> {
  console.log(chalk.bold('\nspacecode stop\n'));

  console.log(chalk.yellow('Sessions auto-sleep when idle -- there is no separate stop action.'));
  console.log('');
  console.log(chalk.dim('If you want to permanently remove a session, use:'));
  console.log(chalk.dim(`  spacecode destroy ${sessionId}`));
  console.log('');

  // Optionally show the session status so the user knows what state it's in
  try {
    const token = await resolveAuthToken();
    const { createSandboxClient } = await import('@spacecode/sandbox-client');
    const client = createSandboxClient(SANDBOX_WORKER_URL, token, sandboxClientOptions(token));

    const info = await client.getSandboxStatus(sessionId);
    console.log(chalk.dim(`Session ${sessionId} is currently: ${info.status}`));
  } catch (error) {
    // If we can't get status, that's fine -- just show the informational message
    console.log(chalk.dim(`Could not retrieve session status: ${error instanceof Error ? error.message : String(error)}`));
  }
}
